module.exports = {
  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  blocks: [],

  data: {
    default: 'rgba(0,0,0,0.3)',
    color: 'rgba(0,0,0,0.3)',
    position: 'center',
    top: '',
    bottom: '',
    left: '',
    right: '',
    float: false
  }
};
